import { Center } from "@chakra-ui/react";
import * as React from "react";
import BounceLoader from "react-spinners/BounceLoader";
import { useAppConfig } from "../../hooks/useAppConfig";
export interface LoadingSpinnerProps {
  isLoading: boolean;
}
export function LoadingSpinner({ isLoading }: LoadingSpinnerProps) {
  const { ctaColor } = useAppConfig();
  return (
    <Center h={"60vh"}>
      <BounceLoader color={ctaColor} loading={isLoading} size={100} />
    </Center>
  );
}
